var map = {
	"./bernerzeitung.svg": 31,
	"./bieler-tagblatt.svg": 32,
	"./blick.svg": 33,
	"./engadiner-post.svg": 34,
	"./frutiglaender.svg": 35,
	"./maz.svg": 36,
	"./missing.svg": 11,
	"./nzz-am-sonntag.svg": 37,
	"./nzz.svg": 38,
	"./pctipp.svg": 39,
	"./persoenlich.svg": 40,
	"./r4tng.svg": 41,
	"./radio-24.svg": 42,
	"./radio-argovia.svg": 43,
	"./sda.svg": 44,
	"./shn.svg": 45,
	"./sonntagszeitung.svg": 46,
	"./srf-10vor10.svg": 47,
	"./srf-3.svg": 48,
	"./srf-arena.svg": 49,
	"./srf-club.svg": 50,
	"./srf-myschool.svg": 51,
	"./srf-tagesschau.svg": 52,
	"./srf.svg": 53,
	"./suedostschweiz.svg": 54,
	"./ta-blick-srf.svg": 55,
	"./ta-sz.svg": 56,
	"./tagesanzeiger.svg": 57,
	"./tv4tng.svg": 58,
	"./videogang.svg": 59,
	"./virgin.svg": 60,
	"./virus.svg": 61,
	"./vsm.svg": 62,
	"./watson.svg": 63
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;